export { FieldTypeIconMap } from './field-type-icon-map'